module.exports = __webpack_public_path__ + "static/img/pic4.6ad6db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/home/pic4.png
// module id = EjiH
// module chunks = 20